var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-after-callback"},[_c('button',{staticClass:"tlsbutton tlsbutton--ripple",style:(_vm.style),on:{"click":_vm.closeModalAndResetStatus}},[_c('span',[_vm._v("ZAMKNIJ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }